import { render, staticRenderFns } from "./ContratoLista.vue?vue&type=template&id=36582c4d&scoped=true"
import script from "./ContratoLista.vue?vue&type=script&lang=js"
export * from "./ContratoLista.vue?vue&type=script&lang=js"
import style0 from "./ContratoLista.vue?vue&type=style&index=0&id=36582c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36582c4d",
  null
  
)

export default component.exports